<template>
  <div>
    <div class="title title-mb">
      <div class="title-block">
        <div class="block"></div>
        <div class="titleText">仓库：{{name || '默认仓库'}} - 新建库区库位</div>
      </div>
    </div>

    <el-form :model="formData" ref="form" :rules="rules" label-width="100px">
      <el-row :gutter="20">
        <el-col :span="12" :xs="12">
          <el-form-item
            :prop="formData.storageAreaCode"
            required
            label='库区'
          >
            <el-input v-model="formData.storageAreaCode" placeholder="请设置库区" ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12" :xs="12">
          <el-form-item
            :prop="formData.storageLocCode"
            required
            label='库位'
          >
            <el-input v-model="formData.storageLocCode" placeholder="请设置库位" ></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12" :xs="12">
          <el-form-item
            :prop="formData.storageTrayCode"
            label="托盘"
          >
            <el-input v-model="formData.storageTrayCode" placeholder="请设置托盘"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import { saveWarehouseDetailsAPI } from '@/api/system/warehousemanagement'
export default {
  components: {},
  data() {
    return {
      name:'',
      formData: {
        warehouseCode:'',
        storageAreaCode:'',
        storageLocCode:'',
        storageTrayCode:''
      },
      rules: {
        storageAreaCode: [
          { required: true, message: '请设置库区', trigger: ['blur', 'change'] }
        ],
        storageLocCode: [
          { required: true, message: '请设置库位', trigger: ['blur', 'change'] }
        ]
      },
      clickFlag: false,
    }
  },
  methods: {
    reset() {
      this.formData = {
        warehouseCode:'',
        storageAreaCode:'',
        storageLocCode:'',
        storageTrayCode:''
      }
      this.resetForm('form')
    },
    getDetail(data) {
      this.name = data.name;
      this.formData.warehouseCode = data.warehouseCode
    },
    submit(callback) {
      if (this.clickFlag) {
        return
      }
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.clickFlag = true
          saveWarehouseDetailsAPI(this.formData)
            .then((res) => {
              this.clickFlag = false
              if (res.flag) {
                this.reset()
                callback(true)
              } else {
                this.$message.error(res.message)
              }
            })
            .catch((error) => {
              this.clickFlag = false
              console.log(error)
            })
        }
      })
    },
  },
}
</script>

<style scoped lang='less'>
@import './form.less';

::v-deep {
  .el-form-item.preview {
    margin-bottom: 0;
  }
  .no-contract-type {
    padding: 30px;
    background-color: #f8f8f8;
    border-radius: 12px;
    text-align: center;
    border: 1px solid #dde4ff;
    margin-bottom: 20px;
  }
}
/deep/ .flex {
  .el-input--suffix .el-input__inner {
    width: 145px;
  }
}
/deep/.area-select-wrap .area-select {
  margin-left: 0px;
  // margin-right: 10px;
}
// .area-select.medium

/deep/ .area-select.medium {
  width: 146px;
  height: 39px;
}
/deep/ .area-select-wrap {
  display: flex;
}
/deep/ .area-select .area-selected-trigger {
  padding: 0 0 0 10px;
}
.flex {
  display: flex;
}
.area-select {
  height: 38px;
}
</style>